import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { AdminPermissions } from 'types/User';

type SectionPermissions = {
  data: {
    isAdmin: boolean;
    isReadOnly: boolean;
  };
};

export const useGetAdministrativesSectionPermissions =
  (): SectionPermissions => {
    const isAdmin: boolean = useSelector(
      (state: State) => state.society?.role?.isAdmin
    );

    const adminPermissions: AdminPermissions = useSelector(
      (state: State) => state.society?.permissions
    );

    const isDemo: boolean = useSelector(
      (state: State) => state.society?.role?.isDemo
    );

    const isReadOnly: boolean = isDemo || adminPermissions?.boards?.readOnly;

    return {
      data: { isAdmin, isReadOnly },
    };
  };
